export default "__VITE_ASSET__CNmwRNHC__"